import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {translate} from 'react-i18next'
import {bindActionCreators} from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Breadcrumb from 'component/Breadcrumb'
import Grid from 'component/utils/Grid'
import FilterForm from 'component/queryLogs/FilterForm'
import TableQueryLog from 'component/queryLogs/Table'
import * as queryLogActions from 'action/queryLog'
import * as reportActions from 'action/report'
import Pagination from 'component/pagination/Pagination'
import Col from 'component/utils/Col'
import moment from 'moment'

let signalController;
class QueryLog extends Component {
  state = {
    isRenderForm: true,
    isRenderTable: false,
    functionality: null,
    paramsState: null,
  }

  componentWillUnmount() {
    if(signalController) {
      signalController.abort()
    }
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      {link: '/', title: translate('mobile.home')},
      {link: '/', title: translate('mobile.register')},
      {title: translate('query.logs')},
    ]

    return <Breadcrumb steps={steps}/>
  }

  mountDataFull = (dt, hour) => {
    const [hours, minutes] = hour.split(':')
    return moment(dt).hours(parseInt(hours, 10)).minutes(parseInt(minutes || 0, 10)).seconds(0).milliseconds(0)
  }

  submit = (params) => {
    const {
      auth: {user},
      fetchQueryLog,
      fetchFilter,
    } = this.props

    if (params.idBranch && params.functionality === 'request.external') {
      params.idBranch = params.idBranch.replace(/^0+/, '') || '0'
    }

    const oldParams = {
      ...params,
    }

    fetchFilter(oldParams)

    const dataSt = params.dtStart
        ? this.mountDataFull(params.dtStart, params.hourStart || '00:00')
        : ''
    let dataEnd = params.dtEnd
        ? this.mountDataFull(params.dtEnd, params.hourEnd || '23:59')
        : ''
    if (dataEnd) {
      if (params.hourEnd) {
        dataEnd = dataEnd.seconds(59).milliseconds(999)
      } else {
        dataEnd = dataEnd.endOf('day')
      }
    }
    params.dtStart = dataSt ? dataSt.utc().format('YYYY-MM-DD HH:mm:ss') : ''
    if (dataEnd && params.hourEnd) {
      params.dtEnd = dataEnd.utc().format('YYYY-MM-DD HH:mm:ss.SSS')
    } else {
      params.dtEnd = dataEnd ? dataEnd.utc().format('YYYY-MM-DD HH:mm:ss') : ''
    }

    signalController = new AbortController()
    fetchQueryLog(user.dsToken, params, signalController)
    this.setState({
      isRenderForm: false,
      isRenderTable: true,
      functionality: params.functionality,
      paramsState: oldParams,
    })
  }

  renderForm = () => {
    const {
      translate,
      filters,
      auth: { user },
    } = this.props

    return (
      <div
        ref={'filter'}
        className='rotative-inventory-filter padding-bottom-double'
      >
        <Grid fluid>
          <FilterForm
            isNewFilter
            filters={filters}
            translate={translate}
            submit={this.submit}
            user={user}
          />
        </Grid>
      </div>
    )
  }

  renderTable = () => {
    const {
      translate,
      list,
      pages,
      count,
      filters,
      current,
      auth: { user },
    } = this.props

    return (
      <TableQueryLog
        translate={translate}
        filters={filters}
        submit={this.submit}
        functionality={this.state.functionality}
        list={list}
        count={count}
        current={current}
        handlePagination={this.handlePagination}
        pages={pages}
        user={user}
      />
    )
  }

  handlePagination = (e) => {
    const params = this.state.paramsState
    params.page = e
    this.submit(params)
  }

  renderPaginaton = () => {
    const { count, current, pages, list } = this.props

    if (current === 1 && list.length < 10) {
      return
    }

    return (
      <Col className='align-center'>
        <Pagination
          count={count}
          current={current}
          getPage={(e) => this.handlePagination(e)}
          pages={pages}
        />
      </Col>
    )
  }

  render() {
    const { translate } = this.props
    const { isRenderForm, isRenderTable } = this.state

    return (
      <div>
        <div ref={'header'}>
          <ContentHeader>{translate('query.logs')}</ContentHeader>

          {this.renderBreadcrumb()}
        </div>

        {isRenderForm && this.renderForm()}

        {isRenderTable && this.renderTable()}

        {isRenderTable && this.renderPaginaton()}
      </div>
    )
  }
}

const mapStateToProps = ({ paginateReducer, queryLogReducer }) => ({
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
  list: queryLogReducer.get.record,
  filters: queryLogReducer.filters,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...queryLogActions,
      ...reportActions,
    },
    dispatch
  )

const QueryLogTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(QueryLog)

export default connect(mapStateToProps, mapDispatchToProps)(QueryLogTranslated)

export { QueryLog }

QueryLog.propTypes = {
  auth: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  fetchQueryLog: PropTypes.func,
  fetchFilter: PropTypes.func,
  filters: PropTypes.object,
  list: PropTypes.array,
  current: PropTypes.number,
  pages: PropTypes.number,
  count: PropTypes.number,
}
